import { Currency } from '@web-solutions/react-billing/constants';
import { COUNTRY_VAT } from '@web-solutions/core/payment/constants';

import { getCurrencySymbols, getPreparedPrice } from '@web-solutions/react-billing/utils/prices';

type Params = {
  amount: string | number;
  currency: Currency;
  countryCode: string;
  displayVAT?: boolean;
};

export const createVATPrice = ({ amount, currency, countryCode, displayVAT }: Params) => {
  const country = countryCode.toLowerCase();
  const { currencySuffix, currencySymbol } = getCurrencySymbols(currency);

  if (!COUNTRY_VAT[country] || !displayVAT) {
    return { vat: '0', price: `${currencySymbol}${amount}${currencySuffix}`, showVat: false };
  }

  const { vat: vatPercent } = COUNTRY_VAT[country];

  const vat = getPreparedPrice(+amount * (vatPercent / (vatPercent + 100)));
  const price = getPreparedPrice(+amount - vat);

  const vatSymbol = `${currencySymbol}${vat}${currencySuffix}`;
  const priceSymbol = `${currencySymbol}${price}${currencySuffix}`;

  return { vat: vatSymbol, price: priceSymbol, vatPercent: `${vatPercent}%`, showVat: true };
};
